import { EmailFlowWidgetSchemaKey } from '@inference.engine/widgets/web';
import {
  makeCreateWidgetAction,
  type MakeCreateWidgetActionDeps,
  type WidgetActionProcessor,
  type WidgetActionSchema,
} from '@/entities/widget';
import { EmailFlowWidgetItemData } from '@inference.engine/widgets';

/**
 * Factory that binds the EmailFlow widget processor to the supplied dep
 * surface. Returns the processor list consumed by the central widget
 * dispatcher in `features/widgets/processors/`.
 *
 * The widget slice MUST NOT value-import `widgetProcessorDeps` from
 * `@/features/widgets/processors/...`. The dispatcher binds with deps once.
 */
export const makeProcessors = (deps: MakeCreateWidgetActionDeps): WidgetActionProcessor[] => {
  const create: WidgetActionProcessor<WidgetActionSchema<EmailFlowWidgetItemData>> = {
    key: EmailFlowWidgetSchemaKey,
    processor: makeCreateWidgetAction(deps) as WidgetActionProcessor<
      WidgetActionSchema<EmailFlowWidgetItemData>
    >['processor'],
  };
  return [create];
};
